module.exports = __webpack_public_path__ + "img/43cce69.jpeg";